/* import __COLOCATED_TEMPLATE__ from './buyer-feedback.hbs'; */
import { computed, observer } from '@ember/object';
import { notEmpty } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import store from 'store2';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';

const LOCAL_STORE_KEY = 'buyerFeedbackAskLater';

export default Component.extend({
  /** @inheritDoc */
  state: service('states/routes/posting'),

  api: service(),

  /** @inheritDoc */
  tagName: '',

  /** @type {boolean} */
  isComplete: false,

  /** @type {boolean} */
  askLater: false,

  /** @type {string} */
  overall: undefined,

  /** @type {number} */
  pruneHandler: 0,

  /** @type {Object} */
  [LOCAL_STORE_KEY]: { },

  /** @type {boolean} */
  hasSentiment: notEmpty('overall'),

  /** @type {boolean} */
  isEligible: computed('state.buyerFeedbackAssignment', 'askLater', 'isComplete', function() {
    if (this.get('askLater')) return false;
    if (this.get('isComplete')) return true;

    const assignment = this.get('state.buyerFeedbackAssignment');

    if (!assignment) return false;
    if (!assignment.get('allow.feedback')) return false;

    // this is intentionally left out of the watch list since we don't want
    // changes to the timeout list to trigger the modal
    if (this.get(`${LOCAL_STORE_KEY}.${assignment.id}`)) return false;

    return true;
  }),

  /** @type {function} */
  assignmentChanged: observer('state.buyerFeedbackAssignment', function() {
    this._setState();
  }),

  /** @inheritDoc */
  init() {
    this._super(...arguments);
    this._pruneTimeouts();

    // prune local storage every 10 minutes
    this.set('pruneHandler', setInterval(() => {
      this._pruneTimeouts();
    }, 1000 * 60 * 10));
  },

  /** @inheritDoc */
  willDestroy() {
    this._super(...arguments);

    const handler = this.get('pruneHandler');

    if (handler) {
      clearInterval(handler);
    }
  },

  /** @inheritDoc */
  actions: {

    /**
     *
     */
    onCompleteCallback() {
      this._setState({ askLater: true });
    },

    /**
     *
     */
    onAskLater() {
      const id = this.get('state.buyerFeedbackAssignment.id');
      const currentTimeouts = store.get(LOCAL_STORE_KEY, { });

      currentTimeouts[id] = Date.now();

      store.set(LOCAL_STORE_KEY, currentTimeouts);
      this.set(LOCAL_STORE_KEY, currentTimeouts);

      this._setState({ askLater: true });
    },

    /**
     *
     * @param {string} overall
     */
    onSentimentClick(overall) {
      switch (overall) {
        case 'happy':
          this._setState({ isComplete: true });
          this._submitForm({ overall });
          break;

        default:
          this._setState({ overall });
          break;
      }
    },

    /**
     *
     * @param {Object} form
     * @returns {Promise}
     */
    onFormSubmit(form) {
      this._setState({ isComplete: true });
      this._submitForm(form);
    },
  },

  /**
   *
   */
  _pruneTimeouts() {
    const currentTimeouts = store.get(LOCAL_STORE_KEY, { });

    const now = Date.now();
    const delay = 1000 * 60 * 60 * 24; // 24 hours

    const pruned = Object.entries(currentTimeouts).reduce((accum, [id, lastSeen]) => {
      if (lastSeen + delay > now) {
        accum[id] = lastSeen;
      }

      return accum;
    }, { });

    store.set(LOCAL_STORE_KEY, pruned);
    this.set(LOCAL_STORE_KEY, pruned);
  },

  /**
   *
   * @param {Object} jsonData
   * @returns {Promise}
   * @private
   */
  _submitForm(jsonData) {
    const assignment = this.get('state.buyerFeedbackAssignment');

    assignment.set('allow.feedback', false);

    return this.get('api').post(`postings/${assignment.id}/buyerAssignmentFeedback`, {
      jsonData,
    }).catch((e) => {
      handleErrorResponseWithModal(
        this,
        e,
        'There was an error submitting your feedback. Please try again later.',
        `buyerFeedback::onFormSubmit - error submitting feedback for assignment [${assignment.id}]`,
      );
      throw e;
    });
  },

  /**
   *
   * @param {string} overall
   * @param {boolean} isComplete
   * @param {boolean} askLater
   * @private
   */
  _setState({ overall = undefined, isComplete = false, askLater = false } = { }) {
    this.setProperties({ overall, isComplete, askLater });
  },
});
